module.exports = __webpack_public_path__ + "img/speaker.b9697017.png";